import Layout from '@/layout';
export default [
  {
    path: '/publishAct',
    name: 'PublishAct',
    component: Layout,
    redirect: '/publishAct/index',
    meta: {
      title: '发布活动',
      icon: 'icon-activity',
      activePath: 'index',
    },
    showChildren: false,
    children: [
      {
        path: 'index',
        name: 'PublishActIndex',
        component: () => import('@/views/publishAct/index.vue'),
        meta: {
          title: '发布活动',
        },
      },
      {
        path: 'detail',
        name: 'PublishActDetail',
        component: () => import('@/views/publishAct/detail.vue'),
        meta: {
          title: '发布活动-编辑详情页',
        },
        hidden: true,
      },
    ],
  },
];
